import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import SchoolYearPeriod from "./components/SchoolYearPeriod";
import UniDivider from "../../unicomponents/UniDivider";
import TermPeriod from "./components/TermPeriod";
import QuarterPeriod from "./components/QuarterPeriod";
import useOrganizationSetting from "../../hooks/useOrganizationSetting";
import useFlexibleData from "../../hooks/useFlexibleData";
import useSchoolYearPeriod from "../../hooks/useSchoolYearPeriod";
import { findInitialSchoolYear } from "../../util/schoolYear";

export default function PeriodSetting() {
  const location = useLocation();
  const paths = location.pathname.split("/");
  // 배열의 두 번째 요소를 schoolId로 사용합니다.
  const schoolId = paths[1];
  //아래 조건으로 데이터를 불러오도록 합니다.
  const conditions = {
    schoolid: schoolId,
  };

  const {
    settingQuery: { data: settingData },
  } = useOrganizationSetting(conditions);

  const {
    schoolYearPeriodQuery: { data: schoolYearPeriodData },
  } = useSchoolYearPeriod(conditions);

  const quarterFlexibleConditions = useMemo(
    () => ({ schoolid: schoolId, main_category: "quarterPeriod" }),
    [schoolId]
  );

  const {
    flexibleDataQuery: { data: quarterPeriodRows },
    createOrUpdateFlexibleData,
  } = useFlexibleData(quarterFlexibleConditions);

  const showQuarterPeriodSection =
    Array.isArray(quarterPeriodRows) && quarterPeriodRows.length > 0;

  //필터를 위한 모음
  const [schoolYearInfo, setSchoolYearInfo] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: null,
    hierarchyTwoId: null,
    organPathForSort: "/",
  });

  useEffect(() => {
    // 초기 학년도: 오늘이 포함된 학년도 기간 우선, 없으면 드롭다운과 동일한 최신순 맨 위
    if (
      schoolYearInfo.schoolYear === null &&
      settingData &&
      settingData.length > 0 &&
      schoolYearPeriodData !== undefined
    ) {
      const initial = findInitialSchoolYear(settingData, {
        periodData: schoolYearPeriodData,
      });
      if (!initial) return;

      setSchoolYearInfo((schoolYearInfo) => ({
        ...schoolYearInfo,
        schoolYear: initial.schoolYear,
        schoolYearId: initial.schoolYearId,
      }));
    }
  }, [settingData, schoolYearPeriodData, schoolYearInfo.schoolYear]);

  const handleSchoolYearDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;

    const organPath = "/" + value;

    if (name === "0") {
      setSchoolYearInfo((schoolYearInfo) => ({
        ...schoolYearInfo,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: null,
        hierarchyTwoId: null,
        organPathForSort: organPath,
      }));
    }

    if (name === "1") {
      setSchoolYearInfo((schoolYearInfo) => ({
        ...schoolYearInfo,
        hierarchyOneId: value === 0 || value === "0" ? null : value,
        hierarchyTwoId: null,
        organPathForSort: organPath,
      }));
    }

    if (name === "2") {
      setSchoolYearInfo((schoolYearInfo) => ({
        ...schoolYearInfo,
        hierarchyTwoId: value === 0 || value === "0" ? null : value,
        organPathForSort: organPath,
      }));
    }
  };
  return (
    <div className="basicWidth mt-4">
      <div className="container">
        <SchoolYearPeriod
          settingData={settingData}
          handleSchoolYearDropdownChange={handleSchoolYearDropdownChange}
          schoolYearInfo={schoolYearInfo}
          setSchoolYearInfo={setSchoolYearInfo}
          schoolId={schoolId}
          conditions={conditions}
        />
        <UniDivider />
        <TermPeriod
          settingData={settingData}
          handleSchoolYearDropdownChange={handleSchoolYearDropdownChange}
          schoolYearInfo={schoolYearInfo}
          setSchoolYearInfo={setSchoolYearInfo}
          schoolId={schoolId}
          conditions={conditions}
        />
        {showQuarterPeriodSection && (
          <>
            <UniDivider />
            <QuarterPeriod
              schoolYearInfo={schoolYearInfo}
              schoolId={schoolId}
              quarterPeriodRows={quarterPeriodRows}
              createOrUpdateFlexibleData={createOrUpdateFlexibleData}
            />
          </>
        )}
      </div>
    </div>
  );
}
